import React, {useEffect, useState} from 'react';
import {mnaQuestions} from "./constant";
import {Typography} from "../../../../designSystem/components/Typography";
import {OptionButton} from "../../../../designSystem/components/OptionButton";

export const MNASF = ({onChangeAnswer}) => {
  const [answers, setAnswers] = useState<{ [key: string]: number }>({});
  const [score, setScore] = useState<number | null>(null);

  const handleChange = (questionId: string, value: number) => {
    const newAnswers = {...answers, [questionId]: value};
    setAnswers(newAnswers);

    // Calculate total score
    const totalScore = Object.values(newAnswers).reduce((acc, curr) => acc + curr, 0);
    setScore(totalScore);
  };

  useEffect(() => {
    onChangeAnswer(score, answers);
  }, [score, answers]);

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="title">
        迷你營養評估表(MNA-SF)
      </Typography>

      <Typography variant="bodyBold">
        請依據近況回答以下問題：
      </Typography>

      {mnaQuestions.map((q) => (
        <div key={q.id} className="flex flex-col mb-4">
          <Typography variant="body">
            {q.question}
          </Typography>
          <div className="flex space-x-4">
            {q.options.map((option) => (
              <OptionButton
                key={option.value}
                isSelected={answers[q.id] === option.value}
                label={option.label}
                onClick={() => handleChange(q.id, option.value)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
